import "./GoodsList.scss";
import React, { useMemo, useState, useEffect } from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import { items as RAW_ITEMS } from "../../../mockData/BlogList";

// Лічильник у localStorage
const visitKey = (id) => `blog_visits_${id}`;
const getVisits = (id) => Number(localStorage.getItem(visitKey(id)) || 0);
const incVisits = (id) => {
  const next = getVisits(id) + 1;
  localStorage.setItem(visitKey(id), String(next));
  return next;
};

export default function GoodsList() {
  // Підготовка даних
  const items = useMemo(() => {
    return RAW_ITEMS.map((it) => ({
      ...it,
      slug: it.link || it.button || it.title.replace(/\s+/g, "-").toLowerCase(),
      baseViews: Number(it.visability || 0),
      extraViews: getVisits(it.id),
    }));
  }, []);

  // Пагінація
  const location = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const initialPage = Number(params.get("page") || 1);
  const [page, setPage] = useState(initialPage);
  const perPage = 9;

  useEffect(() => {
    const p = new URLSearchParams(location.search);
    const current = Number(p.get("page") || 1);
    if (current !== page) {
      p.set("page", String(page));
      const nextSearch = p.toString();
      if (location.search.replace(/^\?/, "") !== nextSearch) {
        history.replace({ search: nextSearch });
      }
    }
  }, [page, history, location.search]);

  const pages = Math.max(1, Math.ceil(items.length / perPage));
  const slice = items.slice((page - 1) * perPage, page * perPage);

  const bump = (id) => {
    const next = incVisits(id);
    const el = document.getElementById(`views-${id}`);
    const base = items.find((x) => x.id === id)?.baseViews || 0;
    if (el) el.textContent = String(base + next);
  };

  return (
    <section className="blogGrid">
      <div className="blogGrid__wrap">
        {slice.map((it) => (
          <article className="postCard" key={it.id}>
            <Link
              to={`/${it.slug}`}
              className="postCard__media"
              onClick={() => bump(it.id)}
            >
              <img
                src={it.img}
                alt={it.title}
                loading="lazy"
              />
              <span className="postCard__date">{it.date}</span>
            </Link>

            <div className="postCard__body">
              <Link
                to={`/${it.slug}`}
                className="postCard__title"
                onClick={() => bump(it.id)}
              >
                {it.title}
              </Link>
              <p className="postCard__desc">{it.desc}</p>

              <div className="postCard__meta">
                <span className="postCard__views">
                  <svg width="18" height="18" viewBox="0 0 24 24">
                    <path
                      d="M12 5c-7 0-10 7-10 7s3 7 10 7 10-7 10-7-3-7-10-7zm0 11a4 4 0 110-8 4 4 0 010 8z"
                      fill="currentColor"
                    />
                  </svg>
                  <span id={`views-${it.id}`}>
                    {it.baseViews + it.extraViews}
                  </span>
                </span>
                <Link
                  to={`/${it.slug}`}
                  className="postCard__cta"
                  onClick={() => bump(it.id)}
                >
                  Детальніше
                  <svg width="18" height="18" viewBox="0 0 24 24">
                    <path
                      d="M13 5l7 7-7 7M5 12h14"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </article>
        ))}
      </div>

      <nav className="blogGrid__pagination" aria-label="Навігація сторінок">
        {Array.from({ length: pages }, (_, i) => i + 1).map((n) => (
          <button
            key={n}
            className={`pageDot ${n === page ? "is-active" : ""}`}
            onClick={() => setPage(n)}
          >
            {n}
          </button>
        ))}
      </nav>
    </section>
  );
}